import { useParams } from 'next/navigation';
import { useEffect } from 'react';

import { routes } from '~constants/routes';
import { useBotAccess } from '~entities/bot/hooks/useBotAccess';
import { useRouter } from '~i18n/navigation';
import { isSafeApp } from '~shared/utils/host';

type Place = 'chat' | 'profile';

export const useBotSafeModeCheck = (place: Place = 'chat') => {
	const router = useRouter();
	const { recipientId = '' } = useParams<{ recipientId?: string }>();

	const { isNsfw, isLoading } = useBotAccess(recipientId);

	useEffect(() => {
		if (isLoading || !isNsfw) return;

		if (isSafeApp) {
			if (place === 'chat') {
				router.replace(routes.chats.home);
			} else {
				router.replace(routes.explore.home);
			}
		}
	}, [isLoading, isNsfw, place, router]);
};
